module.exports = __webpack_public_path__ + "static/img/mouth_07.f0a8fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_07.png
// module id = nr2j
// module chunks = 0